// Generate a random string for the code verifier
function generateRandomString(length) {
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  const values = crypto.getRandomValues(new Uint8Array(length));
  return values.reduce((acc, x) => acc + possible[x % possible.length], '');
}

// Create a SHA-256 hash of the code verifier
async function sha256(plain) {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  const hash = await crypto.subtle.digest('SHA-256', data);
  return hash;
}

// Convert an array buffer to base64 URL format
function base64URLEncode(buffer) {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

// Generate the code challenge from the code verifier
async function generateCodeChallenge(codeVerifier) {
  const hashed = await sha256(codeVerifier);
  return base64URLEncode(hashed);
}

// Initialize the auth flow by generating and storing a code verifier and state
export async function initializeAuthFlow() {
  const codeVerifier = generateRandomString(128);
  const state = generateRandomString(32);
  localStorage.setItem('code_verifier', codeVerifier);
  localStorage.setItem('auth_state', state);
  const codeChallenge = await generateCodeChallenge(codeVerifier);
  return { codeChallenge, state };
}

// Get the stored code verifier
export function getStoredCodeVerifier() {
  return localStorage.getItem('code_verifier');
}

// Get the stored state
export function getStoredState() {
  return localStorage.getItem('auth_state');
}

// Clear stored auth data
export function clearStoredAuthData() {
  localStorage.removeItem('code_verifier');
  localStorage.removeItem('auth_state');
}

// Check if user is authenticated
export async function checkAuthStatus(config) {
  try {
    const response = await fetch(`${config.api.baseUrl}functions/v1/twitch-auth/validate`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        ...config.api.cors.headers,
        'Origin': config.api.cors.origin
      }
    });

    if (!response.ok) {
      const data = await response.json();
      if (data.requiresNewAuth) {
        return { isAuthenticated: false, requiresNewAuth: true };
      }
      throw new Error(data.error || 'Failed to validate authentication');
    }

    const userData = await response.json();
    return { isAuthenticated: true, userData };
  } catch (error) {
    console.error('Auth check failed:', error);
    return { isAuthenticated: false, error: error.message };
  }
}